import React, { forwardRef, useState, useEffect, useRef } from "react";
// import "../../components/CommonStyle.css";
import CalendarImg from "../../Images/calendar.png";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
import MemberServices from "../../services/MemberServices";
import AdminUserService from "../../services/adminUserServices";
import DateFieldLargeDisabled from "../StyledComp/DateFieldLargeDisabled";
import InputFieldSmallDisabled from "../StyledComp/InputFieldSmallDisabled";
import InputFieldExtraLargeDisabled from "../StyledComp/InputFieldExtraLargeDisabled";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import "../../Styles/memberModal.css";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import { RootState } from "../../store/store";
import ReactModal from "react-modal";
import {
  assignMemberPrimaryAddress,
  editMemberPrimaryAddress,
} from "../../store/editMemberapiSlice";
import { useForm } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { FormatUtils } from "../util/FormatUtils";

interface MemberCode {
  [key: string]: any;
}
interface Memberype {
  [key: string]: any;
}
interface AddressData {
  [key: string]: any;
}
interface IProps {
  MemberCode: MemberCode[];
  MemberType: Memberype[];
  AddressData: AddressData;
}

interface IConfiguration {
  [key: string]: any;
}

type FormValues = {
  FirmName: string;
  Address1: string;
  Address2: string;
  City: string;
  County: string;
  State: string;
  Zipcode: string;
  PhoneNumber: string;
  CellPhoneNumber: string;
  FaxNumber: string;
  Email: string;
};

const MDPrimaryAddress: React.FC = () => {
  const currentMember = useAppSelector((state) => state.currentMember);
  console.log(currentMember);
  const dispatch = useDispatch();
  // const addressArray = currentMember.Address;
  // console.log("addressArray", addressArray);
  // if(addressArray!?.length>1){
  // let PersonalAddress = addressArray![0];
  let PrimaryAddress = currentMember.PrimaryAddress;
  // console.log("PersonalAddress", PersonalAddress);

  let address: string[] = [];
  PrimaryAddress?.Address1 && address.push(`${PrimaryAddress.Address1}, `);
  PrimaryAddress?.Address2 && address.push(`${PrimaryAddress?.Address2}, `);
  PrimaryAddress?.City && address.push(`${PrimaryAddress?.City}, `);
  // PrimaryAddress?.County && address.push(`${PrimaryAddress?.County}, `);
  PrimaryAddress?.State && address.push(`${PrimaryAddress?.State} `);
  PrimaryAddress?.Zipcode && address.push(PrimaryAddress?.Zipcode);

  console.log("ADDRESS:", address);
  const [modalOpen, setModalOpen] = useState(false);

  const form = useForm<FormValues>();
  const { register, control, handleSubmit, formState, setValue } = form;
  const { errors, touchedFields, dirtyFields } = formState;
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const formatPhoneNumber = (input: any) => {
    return FormatUtils.formatPhoneNumberWithCCAndExtension(input);
  };

  let [FirmName, setFirmName] = useState<string>(
    PrimaryAddress?.FirmName != undefined ? PrimaryAddress?.FirmName : ""
  );
  const [Address1, setAddress1] = useState(PrimaryAddress?.Address1);
  const [Address2, setAddress2] = useState(PrimaryAddress?.Address2);
  const [City, setCity] = useState(PrimaryAddress?.City);
  const [County, setCounty] = useState(PrimaryAddress?.County);
  const [State, setState] = useState(PrimaryAddress?.State);
  const [Zipcode, setZipcode] = useState(PrimaryAddress?.Zipcode);
  const [PhoneNumber, setPhoneNumber] = useState(
    PrimaryAddress && formatPhoneNumber(PrimaryAddress.PhoneNumber)
  );
  const [CellPhoneNumber, setCellPhoneNumber] = useState(
    PrimaryAddress && formatPhoneNumber(PrimaryAddress?.CellPhoneNumber)
  );
  const [FaxNumber, setFaxNumber] = useState(
    PrimaryAddress && FormatUtils.formatFaxNumber(PrimaryAddress?.FaxNumber)
  );
  const [Email, setEmail] = useState(PrimaryAddress?.Email);

  const [divDisplayState, setdivDisplayState] = useState("none");
  // const [disableInputField, setdisableInputField] = useState<boolean>(true);
  const firmListdivRef = useRef<HTMLDivElement>(null);
  let [inputFirmName, setinputFirmName] = useState<any[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const openMemberEditPrimaryAddressScreen = () => {
    dispatch(
      changeCurrentMemberMenu(screenConfig.memberEditPrimaryAddressScreen)
    );
  };

  const resetEditState = () => {
    setFirmName(PrimaryAddress!.FirmName);
    setAddress1(PrimaryAddress!.Address1);
    setAddress2(PrimaryAddress!.Address2);
    setCounty(PrimaryAddress!.City);
    setCounty(PrimaryAddress!.County);
    setState(PrimaryAddress!.State);
    setZipcode(PrimaryAddress!.Zipcode);
    setPhoneNumber(formatPhoneNumber(PrimaryAddress!.PhoneNumber));
    setCellPhoneNumber(formatPhoneNumber(PrimaryAddress!.CellPhoneNumber));
    setFaxNumber(FormatUtils.formatFaxNumber(PrimaryAddress!.FaxNumber));
    setEmail(Email);
  };

  const editMemberPrimaryAddressBody = useSelector(
    (state: RootState) => state.editMemberapiSlice.PrimaryAddress
  );

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const [isHandleOutsideClickTriggered, setIsHandleOutsideClickTriggered] =
    useState<boolean>(false);
  const [firmNameError, setFirmNameError] = useState<string>("");
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(false);

  useEffect(() => {
    dispatch(
      editMemberPrimaryAddress({
        key: "MemberId",
        value: currentMember.Id as unknown as string,
      })
    );
    dispatch(
      editMemberPrimaryAddress({ key: "AddressType", value: "Primary" })
    );
    const getConfigurationLists = async () => {
      console.log("getAdminList called");
      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    const getFirmDetailList = async () => {
      console.log("getFirmDetailList called");
      const response = await MemberServices.getFirmDetailList();
      console.log("FirmDetailList response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        setinputFirmName(response.data.data);
        // dispatch(updateMemberList(response.data.data));
      } else {
      }
    };

    if (isInitialLoad) {
      setIsInitialLoad(false);
      getFirmDetailList();
      getConfigurationLists();
      dispatch(assignMemberPrimaryAddress(currentMember.PrimaryAddress!));
    }

    setValue("FirmName", FirmName ? FirmName : "-", {
      shouldDirty: true,
    });

    setValue("Address1", Address1 ? Address1 : "-", {
      shouldDirty: true,
    });
    setValue("State", PrimaryAddress?.State ? PrimaryAddress.State : "-", {
      shouldDirty: true,
    });
    setValue("Zipcode", Zipcode ? Zipcode : "-", {
      shouldDirty: true,
    });
    setValue(
      "PhoneNumber",
      PhoneNumber ? formatPhoneNumber(PhoneNumber!) : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "CellPhoneNumber",
      CellPhoneNumber ? formatPhoneNumber(CellPhoneNumber) : "-",
      {
        shouldDirty: true,
      }
    );
    setValue("FaxNumber", FaxNumber ? FormatUtils.formatFaxNumber(FaxNumber) : "-", {
      shouldDirty: true,
    });
    setValue("Email", Email ? Email : "-", {
      shouldDirty: true,
    });
  }, []);

  useEffect(() => {
    //Doing this to trigger validation when selecting firm
    console.log("FirmName USEEffect:", isHandleOutsideClickTriggered);
    setValue("FirmName", FirmName ? FirmName : "", {
      shouldDirty: true,
    });

    setValue("Address1", Address1 ? Address1 : "-", {
      shouldDirty: true,
    });
    setValue("Address2", Address2 ? Address2 : "-", {
      shouldDirty: true,
    });
    setValue("City", City ? City : "-", {
      shouldDirty: true,
    });
    setValue("State", State ? State : "-", {
      shouldDirty: true,
    });
    setValue("County", County ? County : "-", {
      shouldDirty: true,
    });
    setValue("Zipcode", Zipcode ? Zipcode : "-", {
      shouldDirty: true,
    });
  }, [FirmName]);

  useEffect(() => {
    console.log(
      "USEEffect called isHandleOutsideClickTriggered:",
      isHandleOutsideClickTriggered
    );
    isHandleOutsideClickTriggered && handleOutsideClick();
  }, [isHandleOutsideClickTriggered]);

  useEffect(() => {
    console.log("USEEffect divDisplayState", isHandleOutsideClickTriggered);

    if (divDisplayState === "block") {
      console.log("EVENT ADDED");
      document.addEventListener("mousedown", updateIsHandleOutsideClickEnabled);
    } else if (divDisplayState === "none") {
      console.log("EVENT REMOVED");
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    }

    // Cleanup to ensure event is removed on unmount or when condition changes
    return () => {
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    };
  }, [divDisplayState]);

  const updateIsHandleOutsideClickEnabled = (event: MouseEvent) => {
    console.log(
      "updateIsHandleOutsideClickEnabled-start",
      isHandleOutsideClickTriggered
    );
    if (
      firmListdivRef.current &&
      !firmListdivRef.current.contains(event.target as Node)
    ) {
      setIsHandleOutsideClickTriggered(true);
    }
    console.log(
      "updateIsHandleOutsideClickEnabled-end",
      isHandleOutsideClickTriggered
    );
  };

  const validateFirmName = () => {
    if (!FirmName || FirmName.trim() === "") {
      setFirmNameError("");
      setIsSaveDisabled(false);
      return;
    }

    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    if (!isFirmNameExists) {
      setFirmNameError("That firm will be created.");
      setIsSaveDisabled(false);
    } else {
      setFirmNameError("");
      setIsSaveDisabled(false);
    }
  };

  const handleOutsideClick = () => {
    // console.log(firmListdivRef);

    console.log("handleOutsideClick-start:", isHandleOutsideClickTriggered);
    inputFirmName.map((firmListItem: any) => {
      if (firmListItem.FirmName === FirmName) {
        console.log(firmListItem, "-", FirmName);
        console.log("firmItem.FirmName === FirmName");
        handleFirmNameClick(firmListItem);
      }
    });
    setdivDisplayState("none");
    console.log("handleOutsideClicked");
    document.removeEventListener(
      "mousedown",
      updateIsHandleOutsideClickEnabled
    );
    console.log();
    setIsHandleOutsideClickTriggered(false);

    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    if (isFirmNameExists === undefined) {
      console.log("isFirmNameExists:", isFirmNameExists);
      console.log("isFirmNameExists-FirmName:", FirmName);
      // Don't clear the firm name - keep the user's input
      // The firm will be auto-created on save
    } else {
      console.log("FIRM NAME EXIST");
    }
    console.log("handleOutsideClick-end:", isHandleOutsideClickTriggered);
  };

  const States = configurationList.StateList;

  const emptyFunction = (event: React.ChangeEvent<HTMLInputElement>): void => {
    //empty function
  };

  const updateFirmInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    console.log("inputFirmName1:", event.target.value);
    dispatch(
      editMemberPrimaryAddress({
        key: "FirmName",
        value: event.target.value,
      })
    );
    setFirmName(event.target.value);
    // setValue(
    //   "FirmName",
    //   PrimaryAddress?.FirmName ? PrimaryAddress.FirmName : "-",
    //   {
    //     shouldDirty: true,
    //   }
    // );
    setdivDisplayState("block");
    console.log("inputFirmName2:", FirmName);
    // console.log(
    //   inputFirmName.some((firmItem) => {
    //     if (firmItem.FirmName === event.target.value) return true;
    //     else return false;
    //   })
    // );
    // inputFirmName.some((firmItem) => {
    //   if (firmItem.FirmName === event.target.value) setdisableInputField(true);
    //   else setdisableInputField(false);
    // });
    //dispatch(
    // editMemberPrimaryAddress({
    //   key: event.target.name,
    //   value: event.target.value,
    // })
    // );
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("event name:", event.target.name);
    dispatch(
      editMemberPrimaryAddress({
        key: event.target.name,
        value: event.target.value,
      })
    );

    switch (event.target.name) {
      case "Address1":
        setAddress1(event.target.value);
        break;
      case "Address2":
        setAddress2(event.target.value);
        break;
      case "Zipcode":
        setZipcode(event.target.value);
        break;
      case "City":
        setCity(event.target.value);
        break;
      case "County":
        setCounty(event.target.value);
        break;
      case "PhoneNumber":
        setPhoneNumber(formatPhoneNumber(event.target.value));
        break;
      case "CellPhoneNumber":
        setCellPhoneNumber(formatPhoneNumber(event.target.value));
        break;
      case "FaxNumber":
        setFaxNumber(FormatUtils.formatFaxNumber(event.target.value));
        break;
      case "Email":
        setEmail(event.target.value);
        break;
      default:
        console.log("DEFAULT");
        break;
    }

    // setAddress1(event.target.value ? event.target.value : "");
    // switch(event.target.name){
    //   case:
    // }
  };

  const handleFirmFieldClick = (event: React.MouseEvent<HTMLElement>): void => {
    setdivDisplayState("block");
    console.log("inputFirmName0:", FirmName);
    //dispatch(
    // editMemberPrimaryAddress({
    //   key: event.target.name,
    //   value: event.target.value,
    // })
    // );
  };

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    console.log("handleSelect ", event.target.name, event.target.value);

    dispatch(
      editMemberPrimaryAddress({
        key: "State",
        value: event.target.value,
      })
    );

    setValue("State", event.target.value ? event.target.value : "-", {
      shouldDirty: true,
    });

    setState(event.target.value);
  };

  const handleFirmNameClick = (newFirm: any) => {
    console.log("primaryAddress1:", newFirm);
    setdivDisplayState("none");
    setFirmName(newFirm.FirmName ? newFirm.FirmName : "");
    setAddress1(newFirm.Address1 ? newFirm.Address1 : "");
    setAddress2(newFirm.Address2 ? newFirm.Address2 : "");
    setCity(newFirm.City ? newFirm.City : "");
    setCounty(newFirm.County ? newFirm.County : "");
    setState(newFirm.State ? newFirm.State : "");
    setZipcode(newFirm.Zipcode ? newFirm.Zipcode : "");

    // Clear any validation errors since a valid firm was selected
    setFirmNameError("");
    setIsSaveDisabled(false);

    console.log("inputfirmname3:", FirmName);

    dispatch(editMemberPrimaryAddress({ key: "Id", value: newFirm.Id }));
    dispatch(editMemberPrimaryAddress({ key: "FirmId", value: newFirm.Id }));
    dispatch(
      editMemberPrimaryAddress({ key: "FirmName", value: newFirm.FirmName })
    );
    dispatch(
      editMemberPrimaryAddress({ key: "Address1", value: newFirm.Address1! })
    );
    dispatch(
      editMemberPrimaryAddress({ key: "Address2", value: newFirm.Address2! })
    );
    dispatch(editMemberPrimaryAddress({ key: "City", value: newFirm.City! }));
    dispatch(
      editMemberPrimaryAddress({ key: "County", value: newFirm.County! })
    );
    dispatch(editMemberPrimaryAddress({ key: "State", value: newFirm.State! }));
    dispatch(
      editMemberPrimaryAddress({ key: "Zipcode", value: newFirm.Zipcode! })
    );
    // dispatch(
    //   editMemberPrimaryAddress({
    //     key: "PhoneNumber",
    //     value: formatPhoneNumber(newFirm.PhoneNumber!),
    //   })
    // );
    // dispatch(
    //   editMemberPrimaryAddress({
    //     key: "CellPhoneNumber",
    //     value: formatPhoneNumber(newFirm.CellPhoneNumber!),
    //   })
    // );
    // dispatch(
    //   editMemberPrimaryAddress({
    //     key: "FaxNumber",
    //     value: formatPhoneNumber(newFirm.FaxNumber!),
    //   })
    // );
    // dispatch(editMemberPrimaryAddress({ key: "Email", value: newFirm.Email! }));

    setValue("FirmName", newFirm?.FirmName ? newFirm.FirmName : "-", {
      shouldDirty: true,
    });

    setValue("Address1", newFirm?.Address1 ? newFirm.Address1 : "-", {
      shouldDirty: true,
    });
    setValue("State", newFirm?.State ? newFirm.State : "-", {
      shouldDirty: true,
    });
    setValue("Zipcode", newFirm?.Zipcode ? newFirm.Zipcode : "-", {
      shouldDirty: true,
    });
    setValue(
      "PhoneNumber",
      newFirm?.PhoneNumber ? formatPhoneNumber(newFirm.PhoneNumber) : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "CellPhoneNumber",
      newFirm?.CellPhoneNumber
        ? formatPhoneNumber(newFirm.CellPhoneNumber)
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue("Email", newFirm?.Email ? newFirm.Email : "-", {
      shouldDirty: true,
    });
  };

  const handleCancel = () => {
    setModalOpen(false);
    resetEditState();
  };

  const onSubmit = async (data: FormValues) => {
    console.log("INSIDE onSubmit");
    console.log("editMemberPrimaryAddressBody", editMemberPrimaryAddressBody);

    // Check if firm exists
    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    // If firm doesn't exist and user entered a firm name, create it first
    if (!isFirmNameExists && FirmName && FirmName.trim() !== "") {
      console.log("Creating new firm:", FirmName);

      const newFirmData = {
        FirmName: FirmName,
        Address1: Address1 || "No Current Address",
        Address2: Address2 || "",
        City: City || "No Current Address",
        State: State || "",
        Zipcode: Zipcode || "",
        County: County || "",
        FirmAdminEmailId: Email || currentMember.PrimaryAddress?.Email || ""
      };

      try {
        const firmResponse = await AdminUserService.addFirm(newFirmData);
        console.log("Firm creation response:", firmResponse);

        if (firmResponse.data.data != null) {
          if (firmResponse.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Firm Creation Error");
            setAlertBody(firmResponse.data.errors[0].sqlMessage || firmResponse.data.errors[0]);
            return;
          }

          // Get the newly created firm's ID
          const firmIdToUse = firmResponse.data.data[0]?.Id || firmResponse.data.data.Id;
          console.log("New firm created with ID:", firmIdToUse);

          // Update the editMemberPrimaryAddressBody with the new FirmId
          dispatch(editMemberPrimaryAddress({ key: "Id", value: firmIdToUse }));
        } else {
          setShowAlertModal(true);
          setAlertTitle("Firm Creation Error");
          setAlertBody("Failed to create firm");
          return;
        }
      } catch (error) {
        console.error("Error creating firm:", error);
        setShowAlertModal(true);
        setAlertTitle("Firm Creation Error");
        setAlertBody("An error occurred while creating the firm");
        return;
      }
    }

    // Now proceed with updating the address
    const response = await MemberServices.editMemberAddress(
      editMemberPrimaryAddressBody
    );
    console.log("response", response);
    
    // Check for errors first, regardless of data being null/not null
    if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage || response.data.errors[0]);
        return;
    }

    if (response.data.data != null) {
      alert("Address updated successfully");
      dispatch(assignCurrentMember(response.data.data[0]));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
    } else {
      console.log("error"); // This should theoretically not happen if hasErrors is false and success is true
    }

    setModalOpen(false);
  };

  const handleEdit = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    setModalOpen(true);
  };

  return (
    <div className="section-box">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Primary Address</h1>

        {/* <PageLink onClick={openMemberEditPrimaryAddressScreen}>Edit</PageLink> */}
        <PageLink onClick={() => handleEdit()}>Edit</PageLink>
      </div>
      <div className="form-wrapper">
        <div className="input-field-div-wrapper">
          <Label>Firm Name</Label>
          <input
            className="input-field-div input-disabled"
            id="FirmName"
            name="FirmName"
            // value={PrimaryAddress!.FirmName}
            value={
              typeof FirmName != "undefined" || FirmName != null ? FirmName : ""
            }
            disabled={true}
          />
        </div>
        <div className="input-addressfield-div">
          <Label>Address</Label>
          <input
            className="input-field-div input-disabled"
            id="Address"
            name="Address"
            value={address.join("")}
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>County</Label>
          <input
            className="input-field-div input-disabled"
            id="County"
            name="County"
            value={
              typeof PrimaryAddress != "undefined" || PrimaryAddress != null
                ? PrimaryAddress?.County
                : ""
            }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>Phone Number</Label>
          <input
            className="input-field-div input-disabled"
            id="PhoneNumber"
            name="PhoneNumber"
            // value={PrimaryAddress!.PhoneNumber}
            value={
              typeof PhoneNumber != "undefined" || PhoneNumber != null
                ? formatPhoneNumber(PhoneNumber)
                : ""
            }
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Cell Phone Number</Label>
          <input
            className="input-field-div input-disabled"
            id="CellPhoneNumber"
            name="CellPhoneNumber"
            // value={PrimaryAddress!.PhoneNumber}
            value={
              typeof CellPhoneNumber != "undefined" || CellPhoneNumber != null
                ? formatPhoneNumber(CellPhoneNumber)
                : ""
            }
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Fax Number</Label>
          <input
            className="input-field-div input-disabled"
            id="FaxNumber"
            name="FaxNumber"
            // value={PrimaryAddress!.FaxNumber}
            value={
              typeof FaxNumber != "undefined" || FaxNumber != null
                ? FaxNumber!
                : ""
            }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper" style={{ width: "64%" }}>
          <Label>Email ID</Label>
          <input
            className="input-field-div input-disabled"
            id="EmailId"
            name="EmailId"
            // value={PrimaryAddress!.Email}
            value={typeof Email != "undefined" || Email != null ? Email : ""}
            disabled={true}
          />
        </div>
      </div>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Edit Primary Address ({currentMember?.FirstName + " " + currentMember?.LastName})</h1>
          <PageLink onClick={() => handleCancel()}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <div
            className="input-field-div-wrapper"
            style={{
              position: "relative",
              borderColor: "var(--active-border-color)",
            }}
          >
            <Label>Firm Name</Label>
            <input
              className="input-field-div"
              id="FirmName"
              // {...register("FirmName", {
              //   required: "Firm Name is a required field",
              // })}
              // onBlur={onBlur}
              value={
                typeof FirmName != "undefined" || FirmName != null
                  ? FirmName
                  : "-"
              }
              disabled={false}
              autoComplete="off"
              onChange={(e) => {
                updateFirmInput(e);
              }}
              onClick={handleFirmFieldClick}
              onBlur={validateFirmName}
            />
            <p className="form-error" style={{ color: firmNameError ? "red" : "" }}>
              {firmNameError || errors.FirmName?.message}
            </p>
            <div
              className="suggestion-dropdown"
              style={{ position: "absolute", display: divDisplayState }}
              ref={firmListdivRef}
            >
              {inputFirmName
                ?.filter((item: any) => {
                  return item.FirmName != null;
                })
                .filter((item: any) => {
                  const serachItem = FirmName ? FirmName.toLowerCase() : "";
                  const itemFirmName = item.FirmName.toLowerCase();
                  return itemFirmName.startsWith(serachItem);
                })
                .map((item: any) => (
                  <div
                    className="suggested-item-row"
                    key={item.Id}
                    onClick={(event) => handleFirmNameClick(item)}
                  >
                    {item.FirmName}
                    {", "}
                    {item.City}
                  </div>
                ))}
            </div>
          </div>
          <div className="input-addressfield-div mt-2">
            <Label>Address 1</Label>
            <input
              className="input-field-div"
              id="Address1"
              name="Address1"
              // {...register("Address1", {
              //   required: "Address is a required field",
              // })}
              value={
                typeof Address1 != "undefined" || Address1 != null
                  ? Address1
                  : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
              // onClick={handleFirmFieldClick}
            />
            <p className="form-error">{errors.Address1?.message}</p>
          </div>
          <div className="input-addressfield-div">
            <Label>Address 2</Label>
            <input
              className="input-field-div"
              id="Address2"
              name="Address2"
              value={
                typeof Address2 != "undefined" || Address2 != null
                  ? Address2
                  : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
            />
          </div>

          <div className="input-field-div-wrapper mt-0">
            <input
              className="input-field-div-small"
              id="City"
              name="City"
              placeholder=""
              autoComplete="off"
              // disabled={disableInputField}
              value={typeof City != "undefined" || City != null ? City : ""}
              onChange={updateInput}
            />
            <label className="form-label" htmlFor="City">
              City
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <Label>County</Label>
            <input
              className="input-field-div"
              id="County"
              name="County"
              value={
                typeof County != "undefined" || County != null ? County : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
            />
          </div>
          <div className="input-field-div-wrapper">
            <div className="selectfield-label">State</div>
            <select
              className="dropdown-control-large-insidetextfield"
              // {...register("State", {
              //   required: "State is a required field",
              // })}
              // disabled={disableInputField}
              // disabled={
              //   disableInputField
              //     ? errors.State?.message != null
              //       ? false
              //       : true
              //     : false
              // }
              onChange={(e) => {
                handleSelect(e);
              }}
              value={typeof State != "undefined" || State != null ? State : ""}
            >
              <option value={""}>
                {typeof State != "undefined" || State != null ? State : ""}
              </option>
              {States?.map((State: any) => (
                <option key={State.Id} value={State.StateName}>
                  {State.StateName}
                </option>
              ))}
              ;
            </select>
            <p className="form-error">{errors.State?.message}</p>
          </div>
          <div className="input-field-div-wrapper">
            <Label>Zip Code</Label>
            <input
              className="input-field-div"
              id="Zipcode"
              name="Zipcode"
              // {...register("Zipcode", {
              //   required: "Zipcode is a required field",
              // })}
              type="number"
              pattern="[0-9]*"
              value={
                typeof Zipcode != "undefined" || Zipcode != null ? Zipcode : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
              // onClick={handleFirmFieldClick}
            />
            <p className="form-error">{errors.Zipcode?.message}</p>
          </div>
          <div className="input-field-div-wrapper">
            <Label>Phone Number</Label>
            <input
              className="input-field-div"
              id="PhoneNumber"
              name="PhoneNumber"
              // {...register("PhoneNumber", {
              //   required: "PhoneNumber is a required field",
              //   // minLength: { value: 9, message: "Miminum 9 digit is required" },
              //   // maxLength: {
              //   //   value: 10,
              //   //   message: "Maximum 10 digit is allowed",
              //   // },
              // })}
              type="text"
              pattern="[0-9]*"
              value={
                typeof PhoneNumber != "undefined" || PhoneNumber != null
                  ? formatPhoneNumber(PhoneNumber)
                  : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
              // onClick={handleFirmFieldClick}
            />
            <p className="form-error">{errors.PhoneNumber?.message}</p>
          </div>

          <div className="input-field-div-wrapper">
            <Label>Cell Phone Number</Label>
            <input
              className="input-field-div"
              id="CellPhoneNumber"
              name="CellPhoneNumber"
              // {...register("CellPhoneNumber", {
              //   required: "PhoneNumber is a required field",
              //   // minLength: { value: 9, message: "Miminum 9 digit is required" },
              //   // maxLength: {
              //   //   value: 10,
              //   //   message: "Maximum 10 digit is allowed",
              //   // },
              // })}
              type="text"
              pattern="[0-9]*"
              value={
                typeof CellPhoneNumber != "undefined" || CellPhoneNumber != null
                  ? formatPhoneNumber(CellPhoneNumber)
                  : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
              // onClick={handleFirmFieldClick}
            />
            <p className="form-error">{errors.CellPhoneNumber?.message}</p>
          </div>

          <div className="input-field-div-wrapper">
            <Label>Fax Number</Label>
            <input
              className="input-field-div"
              id="FaxNumber"
              name="FaxNumber"
              type="text"
              pattern="[0-9]*"
              value={
                typeof FaxNumber != "undefined" || FaxNumber != null
                  ? FormatUtils.formatFaxNumber(FaxNumber)
                  : ""
              }
              // disabled={disableInputField}
              autoComplete="off"
              onChange={updateInput}
            />
          </div>
          <div className="input-field-div-wrapper">
            <Label>Email ID</Label>
            <input
              className="input-field-div"
              id="Email"
              name="Email"
              // {...register("Email", {
              //   required: "Email is a required field",
              // })}
              autoComplete="off"
              value={typeof Email != "undefined" || Email != null ? Email : ""}
              type="email"
              // disabled={disableInputField}
              onChange={updateInput}
              // onClick={handleFirmFieldClick}
            />
            <p className="form-error">{errors.Email?.message}</p>
          </div>
          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button type="submit" disabled={isSaveDisabled}>Save</Button>
            </div>
          </div>
        </form>
        {/* <DevTool control={control} /> */}
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDPrimaryAddress;
